module.exports = __webpack_public_path__ + "static/media/3.7ea423c7.JPG";